class StickyAddToCart extends HTMLElement {
    constructor() {
        super();
        this.isVisible = false;
        this.variantsVisible = false;
        this.scrollThreshold = 800;
        this.preventHide = false;
        this.isAvailable = false;
        this.buyButtonsBlock = null;
        this.productId = this.dataset.productId;
        this.sessionKey = `sticky-cart-closed-${this.productId}`;
        this.init();
    }

    init() {
        this.findBuyButtonsBlock();
        this.setupVariantUpdateListener();
        this.bindEvents();
        this.checkScrollPosition();
    }

    isStickyClosed() {
        return sessionStorage.getItem(this.sessionKey) === 'true';
    }

    setStickyClosed() {
        sessionStorage.setItem(this.sessionKey, 'true');
    }

    findBuyButtonsBlock() {
        // Find the buy-buttons-block element
        this.buyButtonsBlock = document.querySelector('.buy-buttons-block');
        if (!this.buyButtonsBlock) {
            console.warn('buy-buttons-block element not found, falling back to scroll threshold');
        }
    }

    bindEvents() {

        // Scroll event
        window.addEventListener('scroll', this.handleScroll.bind(this), { passive: true });

        // Button events
        const addToCartBtn = this.querySelector('[data-action="toggle-variants"]');
        const closeBtn = this.querySelector('[data-action="close-sticky"]');
        const closeVariantsBtn = this.querySelector('[data-action="close-variants"]');
        const submitBtns = this.querySelectorAll('[data-action="add-to-cart"]');

        if (addToCartBtn) addToCartBtn.addEventListener('click', this.toggleVariants.bind(this));
        if (closeBtn) closeBtn.addEventListener('click', this.closeSticky.bind(this));
        if (closeVariantsBtn) closeVariantsBtn.addEventListener('click', this.closeVariants.bind(this));

        submitBtns.forEach((btn) => btn.addEventListener('click', this.handleAddToCart.bind(this)));

        this.bindVariantEvents();

        this.listenToMainFormChanges();

        // Check initial visibility based on buy-buttons-block position
        let shouldShowInitially = false;
        
        if (this.buyButtonsBlock) {
            const rect = this.buyButtonsBlock.getBoundingClientRect();
            shouldShowInitially = rect.bottom < 0;
        } else {
            shouldShowInitially = window.scrollY > this.scrollThreshold;
        }

        // Only show initially if user hasn't closed it before
        if (shouldShowInitially && !this.isStickyClosed()) {
            const ele = document.querySelector('sticky-add-to-cart');
            const btn = document.querySelector('.button[data-action="toggle-variants"]');
            const ele2 = document.querySelector('.sticky-add-to-cart__variants')
            if (ele && btn && ele2) {
                ele.classList.add('visible');
                this.isVisible = true;
                let tmp = document.querySelector(`fieldset input[data-option-name="colors"]:checked`);
                if (tmp) {
                    let isAvailable = tmp.dataset.optionAvailable;
                    if (isAvailable === 'false') {
                        window.scrollTo(0, this.scrollThreshold);
                    }
                }
            }
        }
    }

    handleScroll() {
        this.checkScrollPosition();
    }

    checkScrollPosition() {
        // If user has closed the sticky popup, don't show it again
        if (this.isStickyClosed()) {
            return;
        }

        // If we're preventing hide (e.g., after variant change), keep visible
        if (this.preventHide) {
            if (!this.isVisible) {
                this.isVisible = true;
                this.classList.add('visible');
            }
            return;
        }

        // Check if buy-buttons-block is scrolled out of view
        let shouldBeVisible = false;
        
        if (this.buyButtonsBlock) {
            const rect = this.buyButtonsBlock.getBoundingClientRect();
            // Show sticky when buy-buttons-block is completely above the viewport
            shouldBeVisible = rect.bottom < 0;
        } else {
            // Fallback to scroll threshold if buy-buttons-block not found
            shouldBeVisible = window.scrollY > this.scrollThreshold;
        }

        if (shouldBeVisible !== this.isVisible) {
            this.isVisible = shouldBeVisible;
            this.classList.toggle('visible', this.isVisible);
            if (this.isVisible) {
                this.initializeVariantOptions();
                this.syncVariantId();
            }
        }
    }

    toggleVariants() {
        const hasVariants = this.dataset.hasVariants === 'true';
        //console.log("toggleVariants::",this);
        const selectedInput = this.querySelector(`input[data-option-name="size"]:checked`);
        if (selectedInput) {
            //console.log("selectedInput::", selectedInput);

            const isAvailable = selectedInput.dataset.optionAvailable;
            //console.log("isAvailable", isAvailable);

            const btnElement = document.querySelector(".sticky-add-to-cart__submit");
            const stickyBtnElement = document.querySelector(".sticky-add-to-cart__button");
            if (btnElement && stickyBtnElement) {
                // if (isAvailable === "false") {
                //     btnElement.innerHTML = "Out of Stock";
                //     btnElement.setAttribute("disabled", "disabled");
                //     stickyBtnElement.innerHTML = "Out of Stock";
                //     stickyBtnElement.setAttribute("disabled", "disabled");
                // } else {
                //     btnElement.innerHTML = "Add to Cart";
                //     btnElement.removeAttribute("disabled");
                //     stickyBtnElement.innerHTML = "Add to Cart";
                //     stickyBtnElement.removeAttribute("disabled");
                // }

            }
        }



        if (hasVariants) {
            this.variantsVisible = !this.variantsVisible;
            this.showVariants(this.variantsVisible);
        } else {
            this.handleAddToCart();
        }
    }

    showVariants(show) {
        const variantsContainer = this.querySelector('[data-variants-container]');
        const closeBtn = this.querySelector('[data-action="close-variants"]');
        const addToCartBtn = this.querySelector('[data-action="toggle-variants"]');

        if (variantsContainer) {
            variantsContainer.classList.toggle('visible', show);

            if (show) {
                // Unhide any fieldsets/blocks that the theme may hide until first selection
                variantsContainer.querySelectorAll('.variant-option, fieldset, .product-form__input').forEach((el) => {
                    el.style.display = 'block';
                    el.style.visibility = 'visible';
                    el.removeAttribute('hidden');
                    el.classList.remove('is-hidden', 'hidden');
                });

                // Also ensure option buttons and selects are visible
                variantsContainer.querySelectorAll('.variant-option__button-label, select').forEach((el) => {
                    el.style.display = el.tagName === 'SELECT' ? 'block' : 'inline-flex';
                    el.style.visibility = 'visible';
                });

                // Mirror selection from the main PDP picker if present
                this.syncFromMainProductForm();

                // Also sync variant ID
                this.syncVariantId();

                // Re-bind events to newly rendered variant inputs
                setTimeout(() => {
                    this.bindVariantEvents();
                }, 100);
            }
        }

        if (closeBtn) closeBtn.classList.toggle('visible', show);
        if (addToCartBtn) addToCartBtn.style.display = show ? 'none' : 'block';
    }

    closeVariants() {
        this.variantsVisible = false;
        this.showVariants(false);
    }

    closeSticky() {
        this.isVisible = false;
        this.classList.remove('visible');
        this.variantsVisible = false;
        this.showVariants(false);
        this.setStickyClosed();
    }

    initializeVariantOptions() {
        //console.log("initializeVariantOptions");
        // Make sure everything is visible in sticky context
        this.querySelectorAll('.variant-option, fieldset, .product-form__input').forEach((option) => {
            option.style.display = 'block';
            option.style.visibility = 'visible';
            option.removeAttribute('hidden');
            option.classList.remove('is-hidden', 'hidden');
        });

        this.querySelectorAll('.variant-option__button-label, select').forEach((el) => {
            el.style.display = el.tagName === 'SELECT' ? 'block' : 'inline-flex';
            el.style.visibility = 'visible';
        });


        const selectedSizeElement = document.querySelector("fieldset input[data-option-name='size']:checked");
        const stickyBtnElement = document.querySelector(".sticky-add-to-cart__button");
        if (selectedSizeElement && stickyBtnElement) {
            //console.log("selectedSizeElement & stickyBtnElement");
            let isAvailable = selectedSizeElement?.dataset?.optionAvailable;
            if (isAvailable === "false") {
                stickyBtnElement.innerHTML = "Out of Stock";
                stickyBtnElement.setAttribute("disabled", "disabled");
            } else {
                stickyBtnElement.innerHTML = "Add to Cart";
                stickyBtnElement.removeAttribute("disabled");
            }
        }

        // Sync variant ID when initializing
        this.syncVariantId();

        // Bind events to variant inputs
        setTimeout(() => {
            this.bindVariantEvents();
        }, 100);
    }

    // Copy the currently selected options/variant id from the main form (non-sticky)
    syncFromMainProductForm() {
        try {
            const stickyPicker = this;
            const mainForm = this.findMainForm();

            if (!mainForm) {
                return;
            }


            // Copy radios by matching option name and value instead of exact name
            const mainChecked = mainForm.querySelectorAll('input[type="radio"]:checked');
            mainChecked.forEach((chk) => {
                const optionName = chk.dataset.optionName;
                const value = chk.value;

                if (optionName) {
                    // Find corresponding input in sticky form by matching option name and value
                    const target = stickyPicker.querySelector(
                        `input[type="radio"][data-option-name="${optionName}"][value="${CSS.escape(value)}"]`
                    );
                    if (target && !target.checked) {
                        target.checked = true;
                        target.dispatchEvent(new Event('change', { bubbles: true }));
                    }
                }
            });

            // Copy selects by matching option name
            const mainSelects = mainForm.querySelectorAll('select');
            mainSelects.forEach((sel) => {
                const optionName = sel
                    .closest('fieldset')
                    ?.querySelector('legend')
                    ?.textContent?.trim()
                    .split(':')[0]
                    ?.trim()
                    .toLowerCase();
                const value = sel.value;

                if (optionName) {
                    // Find corresponding select in sticky form by matching option name
                    const stickyFieldsets = stickyPicker.querySelectorAll('fieldset');
                    let stickyFieldset = null;
                    for (const fieldset of stickyFieldsets) {
                        const legend = fieldset.querySelector('legend');
                        if (legend && legend.textContent.trim().split(':')[0].trim().toLowerCase() === optionName) {
                            stickyFieldset = fieldset;
                            break;
                        }
                    }
                    if (stickyFieldset) {
                        const targetSel = stickyFieldset.querySelector('select');
                        if (targetSel && targetSel.value !== value) {
                            targetSel.value = value;
                            targetSel.dispatchEvent(new Event('change', { bubbles: true }));
                        }
                    }
                }
            });
        } catch (e) {
            console.error('Error syncing from main form:', e);
        }

        // Also sync the variant ID
        this.syncVariantId();
    }

    // Sync changes from sticky form back to main form
    syncToMainProductForm() {
        try {
            const stickyPicker = this;
            const mainForm = this.findMainForm();

            if (!mainForm) {
                return;
            }
            //console.log("syncToMainProductForm");
            // Sync radio buttons from sticky to main
            const stickyChecked = stickyPicker.querySelectorAll('input[type="radio"]:checked');
            stickyChecked.forEach((chk) => {
                const optionName = chk.dataset.optionName;
                const value = chk.value;

                if (optionName) {
                    // Find corresponding input in main form by matching option name and value
                    const mainInput = mainForm.querySelector(
                        `input[data-option-name="${optionName}"][value="${CSS.escape(value)}"]`
                    );
                    if (mainInput && !mainInput.checked) {
                        mainInput.checked = true;
                        mainInput.dispatchEvent(new Event('change', { bubbles: true }));
                    }
                }
            });

            // Sync selects from sticky to main
            const stickySelects = stickyPicker.querySelectorAll('select');
            stickySelects.forEach((sel) => {
                const optionName = sel
                    .closest('fieldset')
                    ?.querySelector('legend')
                    ?.textContent?.trim()
                    .split(':')[0]
                    ?.trim()
                    .toLowerCase();
                const value = sel.value;

                if (optionName) {
                    // Find corresponding select in main form by matching option name
                    const mainFieldsets = mainForm.querySelectorAll('fieldset');
                    let mainFieldset = null;
                    for (const fieldset of mainFieldsets) {
                        const legend = fieldset.querySelector('legend');
                        if (legend && legend.textContent.trim().split(':')[0].trim().toLowerCase() === optionName) {
                            mainFieldset = fieldset;
                            break;
                        }
                    }
                    if (mainFieldset) {
                        const mainSel = mainFieldset.querySelector('select');
                        if (mainSel && mainSel.value !== value) {
                            mainSel.value = value;
                            mainSel.dispatchEvent(new Event('change', { bubbles: true }));
                        }
                    }
                }
            });
        } catch (e) {
            console.error('Error syncing to main form:', e);
        }
    }

    // Listen to changes in the main product form to sync to sticky form
    listenToMainFormChanges() {
        try {
            const mainForm = this.findMainForm();

            if (!mainForm) {
                return;
            }

            // Listen to radio button changes in main form
            mainForm.querySelectorAll('input[type="radio"]').forEach((input) => {
                input.addEventListener('change', (event) => {
                    
                    // Button state is now updated via VariantUpdateEvent listener
                    // This ensures we use the combined variant's availability, not individual option availability

                    // Only sync if sticky form is visible and has variants
                    if (this.isVisible && this.variantsVisible) {
                        this.syncFromMainProductForm();
                    }
                    // Always sync variant ID when main form changes
                    this.syncVariantId();
                    if (window.okeWidgetApi) {
                        setTimeout(() => { 
                            window.okeWidgetApi.initAllWidgets();
                        }, 3000);
                    }
                });
            });

            // Listen to select changes in main form
            mainForm.querySelectorAll('select').forEach((select) => {
                select.addEventListener('change', (event) => {
                    // Only sync if sticky form is visible and has variants
                    if (this.isVisible && this.variantsVisible) {
                        this.syncFromMainProductForm();
                    }
                    // Always sync variant ID when main form changes
                    this.syncVariantId();
                });
            });
        } catch (e) {
            console.error('Error setting up main form listeners:', e);
        }
    }

    handleVariantChange() {
        // console.log("handleVariantChange::", this);
        // console.log("radio button changed", event.target.dataset);
        // let isAvailable = event?.target?.dataset?.optionAvailable;
        // console.log("isAvailable:::",isAvailable);
        // document.cookie = `isAvailable=${isAvailable}; path=${window.location.href}`;
        this.updateVariantSelection();
        this.syncToMainProductForm();
        this.syncVariantId();

        // Keep sticky bar visible when variants are changed
        //this.keepStickyBarVisible();

    }

    updateVariantSelection() {
        // Prefer the hidden id input maintained by the theme (updated by VariantUpdateEvent)
        const idInput = this.querySelector('input[name="id"]');
        if (idInput && idInput.value) {
            this.selectedVariantId = idInput.value;
            return;
        }

        // Fallback: try to find variant ID from selected options
        // Get selected color and size to find the matching variant
        const selectedColorInput = this.querySelector('input[data-option-name="colors"]:checked, input[data-option-name="color"]:checked');
        const selectedSizeInput = this.querySelector('input[data-option-name="size"]:checked, input[data-option-name="sizes"]:checked');
        
        // If both color and size are selected, try to find the variant ID from the size input
        // (size inputs typically have the combined variant ID)
        if (selectedColorInput && selectedSizeInput && selectedSizeInput.dataset.variantId) {
            this.selectedVariantId = selectedSizeInput.dataset.variantId;
            return;
        }
        
        // Fallback: try radios carrying data-variant-id
        const selectedInput = this.querySelector('input[type="radio"]:checked');
        if (selectedInput && selectedInput.dataset.variantId) {
            this.selectedVariantId = selectedInput.dataset.variantId;
        }
    }

    // Keep sticky bar visible when variants are changed
    keepStickyBarVisible() {
        //console.log('keepStickyBarVisible');
        // Set a flag to prevent hiding for a short time
        this.preventHide = true;

        // Force the sticky bar to be visible immediately
        this.isVisible = true;
        this.classList.add('visible');

        // Clear the flag after 3 seconds to allow normal scroll behavior
        setTimeout(() => {
            this.preventHide = false;
        }, 3000);
    }

    // Helper method to find main form
    findMainForm() {
        // Try multiple selectors to find the main form
        let mainForm = document.querySelector(`form[id^="product-form-"]:not([id$="-sticky"])`);
        if (!mainForm) {
            // Fallback: look for any form with variant picker that's not the sticky one
            mainForm = document.querySelector('form:not([id*="sticky"])');
            if (mainForm && !mainForm.querySelector('.variant-picker')) {
                mainForm = null;
            }
        }
        if (!mainForm) {
            // Another fallback: look for the first form with variant options
            const forms = document.querySelectorAll('form');
            for (const form of forms) {
                if (form.querySelector('input[data-option-name]') && !form.id.includes('sticky')) {
                    mainForm = form;
                    break;
                }
            }
        }
        return mainForm;
    }

    setupVariantUpdateListener() {
        // Listen to VariantUpdateEvent for accurate combined variant availability
        const variantUpdateHandler = (event) => {
            const variant = event.detail.resource;
            const stickyBtnElement = document.querySelector(".sticky-add-to-cart__button");
            
            if (stickyBtnElement) {
                // If variant is null, it means no valid combination exists (e.g., all sizes out of stock for selected color)
                if (!variant || !variant.id) {
                    stickyBtnElement.innerHTML = "Out of Stock";
                    stickyBtnElement.setAttribute("disabled", "disabled");
                    
                    // Remove variant ID from sticky form to prevent adding invalid variant
                    const stickyIdInput = this.querySelector('input[name="id"]');
                    if (stickyIdInput) {
                        stickyIdInput.remove();
                    }
                } else {
                    // Use the combined variant's availability (not individual option availability)
                    let isAvailable = true;
                    
                    if (variant.available === false || variant.available === 'false') {
                        isAvailable = false;
                    } else if (variant.available === true || variant.available === 'true') {
                        isAvailable = true;
                    } else if (variant.available === undefined || variant.available === null) {
                        // If available property doesn't exist, check inventory
                        if (variant.inventory_management === 'shopify' && 
                            variant.inventory_quantity !== undefined && 
                            variant.inventory_quantity <= 0 && 
                            variant.inventory_policy === 'deny') {
                            isAvailable = false;
                        } else {
                            isAvailable = true;
                        }
                    }
                    // Update button state based on combined variant availability
                    if (!isAvailable) {
                        stickyBtnElement.innerHTML = "Out of Stock";
                        stickyBtnElement.setAttribute("disabled", "disabled");
                    } else {
                        stickyBtnElement.innerHTML = "Add to Cart";
                        stickyBtnElement.removeAttribute("disabled");
                    }
                    
                    // ALWAYS update the variant ID in the sticky form, even if out of stock
                    // This ensures the correct variant ID is used when adding to cart
                    // (The server will handle the availability check and prevent adding out-of-stock items)
                    if (variant.id) {
                        let stickyIdInput = this.querySelector('input[name="id"]');
                        if (!stickyIdInput) {
                            stickyIdInput = document.createElement('input');
                            stickyIdInput.type = 'hidden';
                            stickyIdInput.name = 'id';
                            this.appendChild(stickyIdInput);
                        }
                        if (stickyIdInput instanceof HTMLInputElement) {
                            stickyIdInput.value = String(variant.id);
                        }
                    }
                }
            }
            
            this.syncVariantId();
        };
        
        // Listen on document and element to catch events
        document.addEventListener('variant:update', variantUpdateHandler);
        this.addEventListener('variant:update', variantUpdateHandler);
        
        // Store handler for cleanup if needed
        this._variantUpdateHandler = variantUpdateHandler;
    }

    bindVariantEvents() {
        // Listen to radio and select changes
        this.querySelectorAll('input[type="radio"], select').forEach((input) => {
            input.addEventListener('change', this.handleVariantChange.bind(this));
        });

        // Also listen to clicks on swatches and variant buttons
        this.querySelectorAll('.swatch, [data-swatch], .variant-option__button-label').forEach((element) => {
            element.addEventListener('click', () => {
                setTimeout(() => this.handleVariantChange(), 50);
            });
        });
    }

    // Ensure both forms have the same variant ID
    syncVariantId() {
        try {
            const mainForm = this.findMainForm();

            if (!mainForm) {
                return;
            }

            const mainVariantId = document.querySelector('product-form-component form input[name="id"]')?.value;
            const stickyVariantId = this.querySelector('input[name="id"]')?.value;

            if (mainVariantId && stickyVariantId && mainVariantId !== stickyVariantId) {
                // Update sticky form variant ID to match main form
                const stickyIdInput = this.querySelector('input[name="id"]');
                if (stickyIdInput) {
                    stickyIdInput.value = mainVariantId;
                }
            }

            // If sticky form doesn't have a variant ID input, create one
            if (!this.querySelector('input[name="id"]') && mainVariantId) {
                const hiddenInput = document.createElement('input');
                hiddenInput.type = 'hidden';
                hiddenInput.name = 'id';
                hiddenInput.value = mainVariantId;
                this.appendChild(hiddenInput);
            }


        } catch (e) {
            console.error('Error syncing variant ID:', e);
        }
    }

    async handleAddToCart() {
        const hasVariants = this.dataset.hasVariants === 'true';
        let variantId = this.dataset.productId;

        // Get variant ID from form input first (most reliable, updated by VariantUpdateEvent)
        const variantIdInput = this.querySelector('input[name="id"]');
        if (variantIdInput && variantIdInput.value) {
            variantId = variantIdInput.value;
        } else {
            // Fallback: Use selected variant id if present
            this.updateVariantSelection();
            if (hasVariants && this.selectedVariantId) {
                variantId = this.selectedVariantId;
            }
        }
        
        // Check if we have a valid variant ID
        // If no variant ID exists, it means no valid combination is selected (e.g., all sizes out of stock)
        if (hasVariants && !variantId) {
            this.showErrorMessage('Please select an available variant');
            return;
        }

        const submitBtns = this.querySelectorAll('[data-action="add-to-cart"]');
        submitBtns.forEach((btn) => {
            btn.disabled = true;
            btn.textContent = 'Adding...';
        });

        try {
            const formData = new FormData();
            formData.append('id', variantId);
            formData.append('quantity', '1');

            const cartItemsComponents = document.querySelectorAll('cart-items-component');
            let cartItemComponentsSectionIds = [];
            cartItemsComponents.forEach((item) => {
                if (item instanceof HTMLElement && item.dataset.sectionId) {
                    cartItemComponentsSectionIds.push(item.dataset.sectionId);
                }
            });
            formData.append('sections', cartItemComponentsSectionIds.join(','));

            const response = await fetch(Theme.routes.cart_add_url, {
                method: 'POST',
                headers: {
                    'X-Requested-With': 'XMLHttpRequest',
                    Accept: 'text/html',
                },
                body: formData,
            });

            const result = await response.json();

            if (!result.status) {
                const cartAddEvent = new CustomEvent('cart:update', {
                    detail: {
                        resource: result,
                        sourceId: this.dataset.sectionId,
                        data: {
                            source: 'sticky-add-to-cart',
                            itemCount: 1,
                            productId: this.dataset.productId,
                            sections: result.sections,
                        },
                    },
                });
                document.dispatchEvent(cartAddEvent);
                this.showSuccessMessage();
                if (this.variantsVisible) this.closeVariants();
            } else {
                this.showErrorMessage(result.message || 'Error adding to cart');
            }
        } catch (error) {
            console.error('Error adding to cart:', error);
            this.showErrorMessage('Error adding to cart');
        } finally {
            submitBtns.forEach((btn) => {
                btn.disabled = false;
                btn.textContent = 'Add to Cart';
            });
        }
    }

    showSuccessMessage() {
        const message = document.createElement('div');
        message.className = 'sticky-add-to-cart__message sticky-add-to-cart__message--success';
        message.textContent = 'Added to Cart';
        message.style.cssText = `
        position: fixed;
        top: 20px;
        right: 20px;
        background: #4CAF50;
        color: white;
        padding: 12px 20px;
        border-radius: 4px;
        z-index: 9999;
        animation: slideIn 0.3s ease-out;
      `;
        document.body.appendChild(message);
        setTimeout(() => message.remove(), 3000);
    }

    showErrorMessage(errorText) {
        const message = document.createElement('div');
        message.className = 'sticky-add-to-cart__message sticky-add-to-cart__message--error';
        message.textContent = errorText;
        message.style.cssText = `
        position: fixed;
        top: 20px;
        right: 20px;
        background: #f44336;
        color: white;
        padding: 12px 20px;
        border-radius: 4px;
        z-index: 9999;
        animation: slideIn 0.3s ease-out;
      `;
        document.body.appendChild(message);
        setTimeout(() => message.remove(), 5000);
    }
}

customElements.define('sticky-add-to-cart', StickyAddToCart);